"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _componentsBase = require("@telus-uds/components-base");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _utils = require("../utils");
var _OrderedListBase = _interopRequireDefault(require("./OrderedListBase"));
var _Item = _interopRequireDefault(require("./Item"));
var _constants = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const [selectProps, selectedSystemPropTypes] = (0, _componentsBase.selectSystemProps)([_utils.htmlAttrs]);
const StyledOrderedListBase = /*#__PURE__*/(0, _styledComponents.default)(_OrderedListBase.default).withConfig({
  displayName: "OrderedList__StyledOrderedListBase",
  componentId: "components-web__sc-t5az8z-0"
})(_ref => {
  let {
    start
  } = _ref;
  return {
    // Using CSS counters here to have better control over the number styling
    listStyle: 'none',
    counterReset: `${_constants.OL_COUNTER_NAME} ${start - 1}`
  };
});

/**
 * Themed semantic ordered list.
 */
const OrderedList = /*#__PURE__*/_react.default.forwardRef((_ref2, ref) => {
  let {
    children,
    start = 1,
    variant = {},
    tokens = {},
    ...rest
  } = _ref2;
  // Check if children is an array
  const isChildrenArray = Array.isArray(children);

  // Pass any variants and tokens "OrderedList" receives down to the individual list items.
  const childrenWithParentVariantsAndTokens = _react.default.useMemo(() => {
    const addVariantAndTokensToProps = child => {
      const existingChildVariants = child.props?.variant ?? {};
      const existingChildTokens = child.props?.tokens ?? {};
      return /*#__PURE__*/_react.default.cloneElement(child, {
        variant: {
          ...existingChildVariants,
          ...variant
        },
        tokens: {
          ...existingChildTokens,
          ...tokens
        }
      });
    };
    if (variant || tokens) {
      if (isChildrenArray) {
        return children.map(addVariantAndTokensToProps);
      }
      return [addVariantAndTokensToProps(children)];
    }
    return children;
  }, [children, variant, isChildrenArray, tokens]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledOrderedListBase, {
    ...selectProps(rest),
    ref: ref,
    start: start,
    children: childrenWithParentVariantsAndTokens
  });
});
OrderedList.displayName = 'OrderedList';
OrderedList.propTypes = {
  ...selectedSystemPropTypes,
  /**
   * A list of ordered items wrapped in `OrderedList.Item`.
   */
  children: _propTypes.default.node.isRequired,
  /**
   * The position to start the list with.
   */
  start: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  variant: _componentsBase.variantProp.propType,
  tokens: (0, _componentsBase.getTokensPropType)('OrderedList')
};
OrderedList.Item = _Item.default;
var _default = exports.default = OrderedList;